import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { viewOrganization } from '../../../api';

const MarketplaceRedirect = () => {
    const { orgUuidOrSlug } = useParams<{ orgUuidOrSlug: string }>();
    const [error, setError] = useState(false);

    const isUuid = (value: string): boolean => {
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return uuidRegex.test(value);
    };

    useEffect(() => {
        const redirect = async () => {
            try {
                let slug = orgUuidOrSlug;

                // If it's a UUID, fetch the organization to get the slug
                if (isUuid(orgUuidOrSlug)) {
                    const response = await viewOrganization(orgUuidOrSlug);
                    slug = response.data.slug;
                }

                // Redirect to the subdomain
                window.location.href = `https://${slug}.fiyrpod.com`;
            } catch (e) {
                setError(true);
                console.error('Error fetching organization for redirect:', e);
            }
        };

        void redirect();
    }, [orgUuidOrSlug]);

    if (error) {
        return (
            <div>
                <span style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                    Error redirecting to shop. Organization not found.
                </span>
            </div>
        );
    }

    return (
        <div>
            <span style={{ fontSize: '1.2rem', fontWeight: '600' }}>Redirecting to shop...</span>
        </div>
    );
};

export default MarketplaceRedirect;
